import { render, staticRenderFns } from "./CoverImagePopup.vue?vue&type=template&id=7875276c&scoped=true&"
import script from "./CoverImagePopup.vue?vue&type=script&lang=js&"
export * from "./CoverImagePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7875276c",
  null
  
)

export default component.exports